import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=7d852d91&scoped=true&"
import script from "./Message.vue?vue&type=script&lang=ts&"
export * from "./Message.vue?vue&type=script&lang=ts&"
import style0 from "./Message.vue?vue&type=style&index=0&id=7d852d91&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d852d91",
  null
  
)

export default component.exports